import { render, staticRenderFns } from "./AamsTravelRegApproval.vue?vue&type=template&id=3031d8a4&scoped=true&"
import script from "./AamsTravelRegApproval.vue?vue&type=script&lang=js&"
export * from "./AamsTravelRegApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3031d8a4",
  null
  
)

export default component.exports